import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from '@environments/environment';
import { firstValueFrom } from "rxjs";
import { ProfileResponse } from "../../domain/profile.domain";
import { ProfileRepository } from "../../domain/profile.repository";

@Injectable()
export class ProfileHttpRepository extends ProfileRepository {
  private readonly _http = inject(HttpClient);
  private readonly _apiUrl = `${environment.API_URL_BASE}users`;

  async getProfile(): Promise<ProfileResponse> {
    return firstValueFrom(this._http.get<ProfileResponse>(`${this._apiUrl}/profile`));
  }
}
